module.exports = __webpack_public_path__ + "img/noData.465971d5.png";